/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import React, { ReactNode } from 'react';
import { Backdrop, Box } from '@material-ui/core';
import ErrorCard from 'components/ChoreoSystem/ErrorCards/ErrorCard';
import { ReactComponent as UnderMaintenance } from 'components/ChoreoSystem/Images/ErrorPages/UnderMaintenance.svg';
import useStyles from './style';

interface BannerProps {
  isOpen: boolean;
  title: ReactNode;
  description: ReactNode;
}

function UnderMaintenanceBanner({ isOpen, title, description }: BannerProps) {
  const classes = useStyles();

  return (
    <Backdrop open={isOpen} className={classes.backdrop}>
      <Box className={classes.container}>
        <ErrorCard
          title={title}
          description={description}
          image={<UnderMaintenance />}
          testId="under-maintenance-description"
        />
      </Box>
    </Backdrop>
  );
}

export default UnderMaintenanceBanner;
